/* eslint-disable react/boolean-prop-naming */
/* eslint-disable react/jsx-boolean-value */
import PropTypes from "prop-types";
import Image from "next/image";
import Chip from "../../atoms/chip";
import { REVIEWS } from "../../../constants/common/common";
import { formatReviewCount, getIconUrl } from "../../../utils/common";

/**
 * PLPReviewRatings Component
 *
 * Displays the product's best rating and review count, with a button to scroll to the reviews section.
 *
 * @component
 *
 * @param {number} bestRating - Highest rating for the product/category.
 * @param {number} reviewCount - Total number of reviews.
 * @param {function} onScrollToReviews - Scrolls to the reviews section.
 * @param {boolean} isFromPLP - Whether this component is used on PLP page.
 * @param {boolean} showSchema - Whether to include schema.org markup (default: true). Set to false when used inside CustomerReviewsCarousel to avoid duplicates.
 *
 * @returns {JSX.Element}
 */
const PLPReviewRatings = ({ isMobile, bestRating, reviewCount, onScrollToReviews, isFromPLP = false }) => {
  const hasValidRating = bestRating != null && bestRating > 0;
  const hasValidReviewCount = reviewCount != null && reviewCount > 0;

  return (
    <div className="flex gap-8">
      {hasValidRating && (
        <div className="mx-2 w-fit">
          <Chip
            content={bestRating?.toString()}
            startIcon="/icons/vector-rating.svg"
            variant="outlined"
            size="small"
            id="category_rating"
            classes="px-8 gap-4 py-4 text-fnp-500"
            color="default"
          />
        </div>
      )}
      {hasValidReviewCount && (
        <button
          className={`flex items-center ${isMobile ? "gap-4" : "gap-6"} px-2 py-2 text-12 font-400  md:text-14 ${!isFromPLP ? "text-blue-600" : "text-grey-400"}`}
          onClick={onScrollToReviews}
        >
          {formatReviewCount(reviewCount)}
          {!isFromPLP && (
            <>
              <span className="mx-1">{REVIEWS}</span>
              <Image
                src={getIconUrl("/icons/review-chevron.svg")}
                alt={`filter-chevron_icon`}
                width={isMobile ? 12 : 15}
                height={isMobile ? 12 : 15}
              />
            </>
          )}
        </button>
      )}
    </div>
  );
};
PLPReviewRatings.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  bestRating: PropTypes.number,
  reviewCount: PropTypes.number,
  onScrollToReviews: PropTypes.func,
  isFromPLP: PropTypes.bool,
};
export default PLPReviewRatings;
